<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col sm="12">
          <b-card header-class="redmfu">
            <div slot="header">
              <strong v-if="thai_student==1">หัวข้อการประเมิน</strong>
              <strong v-else-if="thai_student==0">Learning Outcomes </strong>
              <strong v-else> </strong>
              <div style="float:right;"
              >
                <b-badge pill variant="warning" class="font-sm text-dark p-2 pr-3 pl-3">Session Timeout :
                                    {{ this.$store.state.timeExp }}
                </b-badge>
              </div>
            </div>
            <!--            <b-form-group label-cols-sm="1"  label-align-sm="right" label-for="nested-street">-->
            <b-form-group label-cols-sm="1" label-align-sm="right" label-for="nested-street">

              <b-row>
                <b-col>
<!--                uu== {{questions}}-->
                <div v-for="question in questions" v-bind:key="question.QUESTION_PK">
                    {{ question.QUESTION_NAME }} <br>
<!--                  <div v-if="item.QUESTION_PK=='8'">-->
                  <b-form-textarea
                    v-if="question.QUESTION_PK==212 "
                    :rows="5"
                    id="QN_212"
                    type="text"
                    autocomplete="QN_212"
                    v-model="QN_212"
                  ></b-form-textarea>
                  <b-form-textarea
                    v-if="question.QUESTION_PK==213"
                    :rows="5"
                    id="QN_213"
                    type="text"
                    autocomplete="QN_213"
                    v-model="QN_213"
                  > </b-form-textarea>
                  <b-form-textarea
                    v-if="question.QUESTION_PK==214"
                    :rows="5"
                    id="QN_214"
                    type="text"
                    autocomplete="QN_214"
                    v-model="QN_214"
                  > </b-form-textarea>
                  <b-form-textarea
                    v-if="question.QUESTION_PK==215"
                    :rows="5"
                    id="QN_215"
                    type="text"
                    autocomplete="QN_215"
                    v-model="QN_215"
                  > </b-form-textarea>
                  </div>
                </b-col>

              </b-row>
              <br>
              <div>
              </div>

            </b-form-group>
            <div slot="footer" class="text-center">
              <b-button type="submit" size="md" class="mr-2" variant="primary" @click="onSubmit">
                <i class="fa fa-dot-circle-o"></i> Submit
              </b-button>

              <b-button type="reset" size="md" class="mr-2" variant="danger" @click="onReset">
                <i class="fa fa-ban"></i> Reset
              </b-button>
            </div>
          </b-card>
        </b-col>
      </b-row>


      <b-row>
        <b-col lg="6"></b-col>
      </b-row>
    </div>

    <b-modal
      v-if="thai_student==1"
      title="คุณกรอกข้อมูลไม่ครบถ้วน"
      class="modal-danger"
      v-model="dangerModal"
      @ok="dangerModal = false"
      ok-variant="danger"
    >{{ current_erorrtxt }}
    </b-modal>
    <b-modal
      v-if="thai_student==0"
      title="You didn’t fill your information completely"
      class="modal-danger"
      v-model="dangerModal"
      @ok="dangerModal = false"
      ok-variant="danger"
    >{{ current_erorrtxt }}
    </b-modal>
  </div>
</template>

<script>
import YimoVueEditor from "../../../node_modules/yimo-vue-editor/src/Editor.vue";
import api from "../../service/api";

export default {
  components: {YimoVueEditor},
  name: "CreatePart10_12",
  data() {
    return {
      student: {},
      current_number: "",
      std_id: "",
      thai_student: "",
      qid: 0,
      current_erorrtxt: "",
      dangerModal: false,
      comment: [],
      questions: [],
      QN_212: "",
      QN_213: "",
      QN_214: "",
      QN_215: "",
      actionUpdate: false,
      actionUpdateRegis: false,
      /*  dataIndb: false,
        radio: [],
        question_id: "",
        ans: "",
        countupdate: 0,
        countinsert: 0,
        length: 0,
        q_1: 0,
        q_7: 0,*/
    };
  },
  computed: {
    state() {
      // console.log("xxxxx=", Boolean(this.value));
      return Boolean(this.value);
    }
  },
  methods: {
    getCurrentStudent(studentid, qid) {
      api
        .getPart10Comment(studentid, qid)
        .then(res => {
          // console.log("res==", res.data.data[0]);
          this.comment=res.data.data[0];
          this.QN_212=this.comment.QN_212;
          this.QN_213=this.comment.QN_213;
          this.QN_214=this.comment.QN_214;
          this.QN_215=this.comment.QN_215;
        })
        .catch(err => {
          this.actionUpdate = false;
          console.log("getStudentGeneral", err.toString());
          // this.$router.push("Logout");
        });
      return this.actionUpdate;
    },
    getErrorTxt: function () {
      this.current_erorrtxt = "";
      var numEror = 0;
      if ([this.QN_212, this.QN_213, this.QN_214, this.QN_215].some(value => value == 0 || value == '' || value == null || value == undefined)) {
        numEror = 1;
      } else {
        numEror = 0;
      }
      if (numEror == 0) {
        this.current_erorrtxt = "";
        this.dangerModal = false;
      } else {
        this.dangerModal = true;
        if (this.thai_student == 1) {
          this.current_erorrtxt = "กรอกข้อมูลไม่ครบ";
        } else {
          this.current_erorrtxt = "You didn’t fill your information completely";
        }
      }
      return numEror;
    },
    nextPart() {
      this.$router.push("main");
    },
    getQuestionnaire(questionnaireid, thaistudent, start) {
      api
        .getQuestionPart10(questionnaireid, thaistudent, start)
        .then(res => {
            this.questions = res.data.data;
          }
        )
        .catch(err => {
          console.log("2 getQuestionBySection", err.toString());
        });
    },
  getCurrentUserQuestion(studentid) {
      api
        .getStudentUserQuestionById(studentid)
        .then(res => {
          // console.log("getCurrentUserQuestion==", res.data.data[0].QUESTIONNAIRE_1);
          if (res.data.data.length ==1) {
            this.q_1 = res.data.data[0].QUESTIONNAIRE_1;
            this.actionUpdateRegis = true;
            if (this.q_1!=1){
              if (this.thai_student == 1) {
                this.current_erorrtxt = "กลับไปกรอกข้อมูล แบบสอบถามภาวะการมีงานทำของบัณฑิต ก่อน";
              } else {
                this.current_erorrtxt = "Back to fill your Graduate Employability Survey";
              }
              this.dangerModal = true;
            }
          } else {

            this.actionUpdateRegis = false;
            this.q_1 = 0;
          }
        })
        .catch(err => {
          this.actionUpdateRegis = false;
          console.log("getStudentUserQuestionById error", err.toString());
        });
    },
    onUpdateData(student) {
      api
        .updatePart10Comment(student)
        .then(res => {
          // console.log("res==",res)
          if (res.data.code==200){
            this.nextPart();
          }else{
            this.$router.push("part10_12");
          }
        })
        .catch(err => {
          console.log("onUpdateData", err.toString());
          // this.$router.push("login");
        });
    },
    onReset() {
    //  this.radio10 = "";
      this.QN_212="";
      this.QN_213="";
      this.QN_214="";
      this.QN_215="";
    },
    onSubmit: function () {
      var error = this.getErrorTxt();
      // console.log("nerror=", error);
      if (error == 0) {
        var student = {};
        student.std_id = this.$store.state.user.studentid;
        student.qn_year = this.$store.state.user.year;
        student.QN_212 = this.QN_212;
        student.QN_213 = this.QN_213;
        student.QN_214 = this.QN_214;
        student.QN_215 = this.QN_215;
        // console.log("student==",student)
        this.onUpdateData(student);
      }
    }
  },
  created() {

    if (this.$store.state.user.token == null || this.$store.state.user == null) {
      this.$router.push("/logout");
    } else {
      this.std_id = this.$store.state.user.studentid;
      this.actionUpdateRegis=this.getCurrentUserQuestion(this.std_id);

      if ((this.$store.state.user != null) && (this.$store.state.user != undefined) && (this.$store.state.user != '')) {

        this.thai_student = this.$store.state.user.thaistudent;
        this.qid = 212;
        this.actionUpdate = this.getCurrentStudent(this.std_id, this.qid);
        this.getQuestionnaire(10, this.thai_student, this.qid);
        // this.getAnsLoop(this.qid, this.thai_student, 5);
        api.onSetHeader();
      } else {
        this.$router.push("/logout");
      }
    }

  }
};
</script>
<style>
</style>
